import { defineComponent as l, openBlock as o, createBlock as r, unref as c, mergeProps as s, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ l({
  name: "IconReassuranceSmileyOutlined",
  __name: "IconReassuranceSmileyOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (u, a) => (o(), r(c(m), s(n, { "view-box": "0 0 48 48" }), {
      default: p(() => [...a[0] || (a[0] = [
        e("path", { d: "M15.37 39.87A16.4 16.4 0 0 0 23 41.74 18 18 0 0 0 34.926 37l-.416 2.67a.5.5 0 0 0 .42.57H35a.51.51 0 0 0 .49-.44l.7-4.52-4.52-.7A.51.51 0 0 0 31.1 35a.5.5 0 0 0 .43.59l2.96.462-.03.03A17 17 0 0 1 23 40.74 15.4 15.4 0 0 1 15.86 39c-6.18-3.19-9.29-9.71-8.11-17a17.24 17.24 0 0 1 6.33-10.54 18.16 18.16 0 0 1 11.61-4.2C28.18 7.3 34.37 8 38.02 13.37c4.706 6.75 1.17 14.523 1.001 14.896L39.02 28.27a.5.5 0 1 0 .9.42c.21-.35 4-8.66-1-15.88-3.99-5.78-10.57-6.55-13.21-6.55a19 19 0 0 0-12.26 4.43 18.18 18.18 0 0 0-6.69 11.12c-1.24 7.72 2.06 14.64 8.61 18.06" }, null, -1),
        e("path", { d: "M19 31.05a9.7 9.7 0 0 0 5 1.31A12.8 12.8 0 0 0 32.48 29a11.8 11.8 0 0 0 3.09-4.78.5.5 0 0 0-.94-.34 10.85 10.85 0 0 1-2.86 4.39A11.84 11.84 0 0 1 24 31.36a8.7 8.7 0 0 1-4.38-1.21 10.22 10.22 0 0 1-4.547-6.827L17.6 24.85A.5.5 0 0 0 18.12 24l-3.91-2.4-2.38 3.91a.5.5 0 0 0 .43.76.5.5 0 0 0 .43-.27l1.417-2.298A11.22 11.22 0 0 0 19 31.05" }, null, -1),
        e("path", { d: "M24 20.59c.58-1.63.5-3.14-.18-3.38s-1.7.88-2.28 2.5-.5 3.14.18 3.38 1.7-.88 2.28-2.5m6.04-3.56c.68.24.76 1.76.18 3.38-.58 1.59-1.61 2.74-2.28 2.5s-.75-1.76-.17-3.38 1.59-2.74 2.27-2.5" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
